Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.FilterPhotos = Marionette.Behavior.extend({
        initialize: function() {
            var _this = this;
            Cookies.json = true;
            var collection = App.widget.currentView.collection;
            collection.once('sync', function() {
                var cookie = Cookies.get('pixlee_social_cookie') || Cookies.get('pixlee_social_cookie_legacy');
                _this.initialUrl = collection.url();
                if (cookie && cookie.social_login && cookie.social_login.social_id) {
                    _this.processCollection(cookie);
                }
            });

            App.commands.setHandlers({
                "social:login": function(data) {
                    _this.processCollection(data);
                },
                "social:login:loaded": function() {
                    _this.socialLoginLoad();
                }
            });

        },
        ui: {
            location_alert_overlay: "#location_alert_content",
            location_alert_allow: "#location_alert_allow",
            location_alert_deny: "#location_alert_deny",
            sign_in: "#sign_in",
            logged_in_container: "#logged_in_container",
            search_box: "#search_box",
            loading_social_auth: "#loading_social_auth",
            dropdown_list: "#dropdown_list",
            filter_tile: ".filter_tile",
            log_in_container: "#log_in_container",
            interaction_toggle: "#interaction_toggle",
            sort_votes: '[data-attr="sortByVotes"]'
        },
        events: {
            'click #sign_in': function() {
                this.ui.search_box.val('');
                this.ui.loading_social_auth.css('visibility', 'visible');
                var _this = this;
                var data = {
                    name: 'pixlee:show:social:connect',
                    type:'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {
                        widgetId: window.parentIFrame.getId()
                    }
                };
                window.parent.postMessage(JSON.stringify(data), '*');
                return false;
            },
            'click .filter_tile': function(e) {
                var _this = this;
                App.commands.execute('filtered:by', $(e.currentTarget).attr('data-attr'));
                this.selectAllPhotosFilter();
                this.showLoader();
                this.ui.dropdown_list.hide();
                var collection = App.widget.currentView.collection;
                var url;

                if ($(e.target).hasClass('active')) {
                    this.ui.filter_tile.removeClass('active');
                    url = this.initialUrl + '&filterBy=allPhotos';
                } else {
                    this.ui.filter_tile.removeClass('active');
                    $(e.currentTarget).addClass('active');
                    url = this.initialUrl + '&filterBy=' + $(e.currentTarget).attr('data-attr');
                }
                this.fetchCollection(url);
                return false;
            },
            'keyup #search_box': function(e) {
                clearTimeout(this.timer);
                var _this = this;
                this.timer = setTimeout(function() {
                    App.commands.execute('filtered:by', 'search');
                    var caption = $(e.currentTarget).val().trim();
                    var url;

                    _this.selectAllPhotosFilter();

                    $('#widget').find('.clearfix').addClass('loading_content_spinner');
                    if (caption.length > 0) {
                        url = _this.initialUrl + '&filterBy=' + 'caption' + '&caption=' + caption;
                    } else {
                        url = _this.initialUrl;
                    }

                    _this.fetchCollection(url);
                    _this.ui.filter_tile.removeClass('active');
                }, 1000);
            },
            'click #clear_search': function() {
                this.ui.search_box.val('').trigger('keyup');
                return false;
            },
            'click .filter_box': function() {
                this.ui.search_box.val('');
                return false;
            }
        },
        onRender: function() {
            var currentAlbum = App.request("get:current:album");
            var hasVoteCount = currentAlbum.get("campaign");
            if (hasVoteCount !== true) {
                this.ui.sort_votes.hide();
            }
        },
        fetchCollection: function(url) {
            $('.load_more').hide();
            var collection = App.widget.currentView.collection;
            var _this = this;
            collection.paginator_core.url = url;
            collection.url = function() {
                return url;
            };

            collection.goTo(1, {
                success: function() {
                    _this.hideLoader();
                    $('.load_more').show();
                },
                reset: true
            });
        },
        socialLoginLoad: function() {
            this.ui.sign_in.show();
            this.ui.loading_social_auth.css('visibility', 'hidden');
        },
        editCollectionUrl: function(data) {
            var collection = App.widget.currentView.collection;
            var url;
            if (data.source) {
                url = this.initialUrl + '&platform=' + data.source + '&access_token=' + data.access_token + '&access_token_secret=' + data.access_token_secret + '&social_id=' + data.social_id;
            } else {
                url = this.initialUrl + '&platform=email&' + 'email=' + data;
            }
            return url;
        },
        initCollectionEvents: function() {
            var _this = this;
            var collection = App.widget.currentView.collection;
            _this.defaultUrl = collection.url();
            collection.on('sync', function() {
                _this.hideLoader();
                if (collection.length > 0) {
                    $('#widget').find('.clearfix').removeClass('no_photos_view');
                    if (collection.next) {
                        $('.load_more').show();
                    }
                    if ($('.mosaic_frame').length > 0) {
                        $('.mosaic_frame').removeClass('no-pad');
                    }
                } else {
                    $('#widget').find('.clearfix').empty();
                    if ($('.mosaic_frame').length > 0) {
                        $('.mosaic_frame').addClass('no-pad');
                    }
                    $('#widget').find('.clearfix').addClass('no_photos_view');
                }
            });
        },
        signOut: function() {
            var _this = this;
            this.showLoader();
            Cookies.remove('pixlee_social_cookie');
            this.ui.log_in_container.show();
            this.ui.logged_in_container.hide();
            this.hideDropdown();
            this.ui.interaction_toggle.off('click');
            var e = 'click';
            if ('ontouchstart' in window) {
                e = 'touchstart';
            }
            this.ui.logged_in_container.find('#dropdown_list').find('.dropdown_list_item').off(e);
            var url = _this.defaultUrl;
            this.fetchCollection(url);
            $('.checked').removeClass('checked');
            $('.dropdown_list_item').first().addClass('checked');
        },
        hideDropdown: function() {
            this.ui.logged_in_container.find('#dropdown_list').hide();
        },
        showLoader: function() {
            $('#widget').find('.clearfix').removeClass('no_photos_view').addClass('loading_content_spinner');
        },
        hideLoader: function() {
            $('#widget').find('.clearfix').removeClass('loading_content_spinner');
        },
        selectAllPhotosFilter: function() {
            this.ui.interaction_toggle.removeClass().addClass('all_photos');
            this.ui.dropdown_list.find('.checked').removeClass('checked');
            $('[data-attr="allPhotos"]').addClass('checked');
        },
        processCollection: function(data) {
            var _this = this;

            Cookies.set('pixlee_social_cookie', data, { expires: 365 });
            Cookies.set('pixlee_social_cookie_legacy', data, { expires: 365 });

            _this.initCollectionEvents();
            var collection = App.widget.currentView.collection;
            if (data.social_login) {
                var url = this.editCollectionUrl(data.social_login);
                collection.paginator_core.url = url;
            } else {
                return false;
            }
            if (data.platform == 'facebook' || data.platform == "email") {
                $('.dropdown_list_item[data-attr="friendsPhotos"]').remove();
            }
            this.ModifiedUrl = url;
            this.ui.log_in_container.hide();
            this.ui.logged_in_container.show();
            this.ui.interaction_toggle.on('click', function() {
                _this.ui.logged_in_container.find('#dropdown_list').toggle();


                var hideDropdownListener = function() {
                    $('body').click(function(e) {
                        _this.ui.dropdown_list.hide();
                    });
                };

                hideDropdownListener();
            });
            var e = 'click';
            if ('ontouchstart' in window) {
                e = 'touchstart';
            }

            this.ui.logged_in_container.find('#dropdown_list').find('.dropdown_list_item').on(e, function() {

                if ($(this).hasClass('checked')) {
                    return false;
                }
                if ($(this).attr('data-attr') == 'signOut') {
                    _this.signOut();
                    return false;
                }
                _this.ui.logged_in_container.find('#dropdown_list').find('.dropdown_list_item').removeClass('checked');
                $("#desktop_tablet_view").find('.active').removeClass('active');
                $(this).addClass('checked');
                _this.ui.interaction_toggle.attr('class', $(this).attr('data-text'));

                var url;

                if ($(this).attr('data-attr') != "nearMe") {
                    _this.currentSelection = $(this).attr('data-text');
                }

                if ($(this).attr('data-attr') == 'allPhotos') {
                    url = _this.ModifiedUrl + '&filterBy=allPhotos';
                    App.commands.execute('filtered:by', 'allPhotos');
                    _this.hideDropdown();
                } else if ($(this).attr('data-attr') == 'nearMe') {
                    _this.ui.location_alert_overlay.show();

                    var clickAllowGeoListener = function(nearMeElement) {
                        _this.ui.location_alert_allow.click(function() {
                            _this.hideDropdown();
                            _this.showLoader();
                            _this.ui.location_alert_overlay.hide();
                            $('.load_more').hide();
                            App.commands.execute('filtered:by', $(nearMeElement).attr('data-attr'), 'location');
                            if (navigator.geolocation) {
                                collection.reset();
                                navigator.geolocation.getCurrentPosition(function(position) {
                                    var lat = position.coords.latitude;
                                    var lng = position.coords.longitude;
                                    url = _this.ModifiedUrl + '&filterBy=' + $(nearMeElement).attr('data-attr') + '&latitude=' + lat + '&longitude=' + lng;
                                    _this.fetchCollection(url);
                                    _this.hideDropdown();
                                    return false;

                                });
                            }
                        });
                    };
                    var clickDenyGeoListener = function(nearMeElement) {
                        _this.ui.location_alert_deny.click(function() {
                            _this.showLoader();
                            _this.selectAllPhotosFilter();
                            url = _this.ModifiedUrl + '&filterBy=allPhotos';
                            _this.fetchCollection(url);
                            _this.ui.location_alert_overlay.hide();
                            _this.hideDropdown();
                            return false;
                        });
                    };

                    clickAllowGeoListener(this);
                    clickDenyGeoListener(this);

                } else if ($(this).attr('data-attr') == 'caption') {
                    App.commands.execute('filtered:by', $(this).attr('data-attr'), 'search');
                    var caption = 'hello';
                    url = _this.ModifiedUrl + '&filterBy=' + $(this).attr('data-attr') + '&caption=' + caption;
                    _this.hideDropdown();
                } else {
                    App.commands.execute('filtered:by', $(this).attr('data-attr'), data.platform);
                    url = _this.ModifiedUrl + '&filterBy=' + $(this).attr('data-attr');
                    _this.hideDropdown();
                }
                if ($('.mosaic_frame').length > 0) {
                    $('#widget').find('.clearfix').empty();
                }
                if ($(this).attr('data-attr') != 'nearMe') {
                    _this.showLoader();
                    _this.fetchCollection(url);
                    return false;
                }

            });
        }
    });



});
